// MustacheJS-Doku: https://www.npmjs.com/package/mustache
mp.templates = {
    searchNav:
        '<div class="dropdown-menu" role="menu">' +
        '<div class="container-fluid">' +
        '<div class="row no-gutters">' +
        '<div class="col-12 col-md-3">' +
        '<nav class="nav" id="mpSearchNavTabs" role="tablist" aria-orientation="vertical">' +
        '{{#nav}}' +
        '<a href="#mpSearchNavTabC{{key}}" onclick="document.location=\'{{link}}\'" class="dropdown-item" id="mpSearchNavTab{{key}}" data-toggle="tab" role="tab" aria-controls="mpSearchNavTabC{{key}}" aria-selected="false">{{label}}</a>' +
        '{{/nav}}' +
        '</nav>' +
        '</div>' +
        '<div class="col-9 d-none d-md-block">' +
        '<div class="tab-content" id="mpSearchNavTabContent">' +
        '{{#tab}}' +
        '<div class="tab-pane mpCategory-{{id}}" id="mpSearchNavTabC{{key}}" role="tabpanel">' +
        '<div class="row">' +
        '<div class="col-12 clearfix">' +
        '<strong>{{headline}}</strong>' +
        '<a href="{{linkPetition}}" class="btn btn-info btn-sm">{{misc.petitions}} {{amountPetition}}</a>' +
        '<hr/>' +
        '</div>' +
        '</div>' +
        '<div class="row">' +
        '{{#links}}' +
        '<div class="col-4">' +
        '{{#.}}' +
        '<a href="{{link}}" class="dropdown-item">{{label}}</a>' +
        '{{/.}}' +
        '</div>' +
        '{{/links}}' +
        '</div>' +
        '</div>' +
        '{{/tab}}' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="row no-gutters d-none d-md-flex flex-fill mpCTA">' +
        '<div class="col-12 d-flex align-items-center justify-content-between">' +
        '<strong>{{misc.cta}}</strong>' +
        '<a href="/login" class="btn btn-primary btn-sm">{{misc.ctaButton}}</a>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>',

    googleOverlay: '<div class="mpGoogleMap" style="height:94%;width:100%" data-marker="{{marker}}"></div>',

   // auch als HTML-Template in box-offerimages.smarty.php
    offerImgSortable: '<li class="mpSortable mb-3 mr-3" draggable="true">' +
            '<div class="mpImageCheckbox">' +
                '<input type="checkbox" id="mpImg{{id}}" name="OfferImageFieldset[offerImages][]" value="{{id}}{{ext}}" checked="checked"/>' +
                '<label for="mpImg{{id}}"> </label>' +
            '</div>' +
            '<img src="{{fileThumb}}" alt=""/>' +
        '</li>',

    // auch als HTML-Template in box-offerimages.smarty.php
    vendorImage: '<h5>' + mpData.translate['preview'] + '</h5>' +
        '<img src="{{filePreview}}" class="img-fluid" alt=""/>',

    headerSearch: '<div class="mpResult col-md">' +
            '{{#brands.image_c}}' +
                '<div class="bg-primary text-dark text-center font-weight-bold p-1 mb-1">' + mpData.translate['topManufacturer'] + '</div>' +
                '{{^brands.any}}' +
                    '<div class="alert alert-info">' + mpData.translate['notFound.brands'] + '</div>' +
                '{{/brands.any}}' +
                '<div class="list-group list-group-flush row no-gutters">' +
                '{{#brands.image_d}}' +
                    '<a href="{{URL}}" data-tracking="headerSearchImage" data-tracking-ident="{{URL}}" class="list-group-item list-group-item-action bg-white text-center border-0 col-6"><img src="{{image}}"/></a>' +
                '{{/brands.image_d}}' +
                '</div>' +
            '{{/brands.image_c}}' +
            '{{#brands.c}}' +
                '<div class="bg-primary text-dark text-center font-weight-bold p-1 mb-1">' + mpData.translate['more.brands'] + '</div>' +
                '<div class="list-group list-group-flush">' +
                '{{#brands.d}}' +
                    '<a href="{{URL}}" data-tracking="headerSearch" data-tracking-ident="{{URL}}" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">{{name}}<span class="badge badge-primary badge-pill">{{cnt}}</span></a>' +
                '{{/brands.d}}' +
                '</div>' +
            '{{/brands.c}}' +
            '</div>' +

        '<div class="mpResult mpResultCat col-md">' +
        '{{#brand_in_categories.any}}' +
            '<div class="bg-primary text-dark text-center font-weight-bold p-1 mb-1">' + mpData.translate['manufacturer'] + ' "{{brand_in_categories.brand.name}}" ' + mpData.translate['in.categories'] + '</div>' +
            '{{#brand_in_categories.c}}' +
                '<div class="list-group list-group-flush">' +
                '{{#brand_in_categories.d}}' +
                    '<a href="{{URL}}" data-tracking="headerSearch" data-tracking-ident="{{URL}}" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">{{name}}<span class="badge badge-primary badge-pill">{{cnt}}</span></a>' +
                '{{/brand_in_categories.d}}' +
                '</div>' +
            '{{/brand_in_categories.c}}' +
        '{{/brand_in_categories.any}}' +
        //'{{#categories.any}}' +
            '{{#categories.image_c}}' +
                '<div class="bg-primary text-dark text-center font-weight-bold p-1 mb-1">' + mpData.translate['area'] + '/ ' + mpData.translate['category'] + '</div>' +
                '{{^categories.any}}' +
                '   <div class="alert alert-info">' + mpData.translate['notFound.categories'] + '</div>' +
                '{{/categories.any}}' +
                '<div class="list-group list-group-flush row no-gutters">' +
                '{{#categories.image_d}}' +
                    '<a href="{{URL}}" data-tracking="headerSearchImage" data-tracking-ident="{{URL}}" class="list-group-item list-group-item-action bg-white border-0 col-6">' +
                        '<div class="mpImg mpCategory-{{area_id}} mpHasLabel"><div class="mpImgWrap"><div class="mpImgBg"></div></div><div class="mpImgLbl">{{name}}</div></div>' +
                    '</a>' +
                '{{/categories.image_d}}' +
                '</div>' +
            '{{/categories.image_c}}' +
            '{{#categories.c}}' +
                '<div class="bg-primary text-dark text-center font-weight-bold p-1 mb-1">' + mpData.translate['more.categories'] + '</div>' +
                '<div class="list-group list-group-flush">' +
                '{{#categories.d}}' +
                    '<a href="{{URL}}" data-tracking="headerSearch" data-tracking-ident="{{URL}}" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">{{name}}<span class="badge badge-primary badge-pill">{{cnt}}</span></a>' +
                '{{/categories.d}}' +
                '</div>' +
            '{{/categories.c}}' +
        //'{{/categories.any}}' +
        '</div>' +

        '<div class="mpResult col-md">' +
        '{{^offers.any}}' +
            '<div class="bg-primary text-dark text-center font-weight-bold p-1 mb-1">' + mpData.translate['topOffers'] + '</div>' +
            '<div class="alert alert-info">' + mpData.translate['notFound.offers'] + '</div>' +
            '<div><a href="{{linkSearchURL}}" class="btn btn-secondary btn-lg w-100 rounded-0" data-tracking="headerSearchAllOffers">' + mpData.translate['allOffers'] + '</a></div>' +
        '{{/offers.any}}' +
        '{{#offers.image_c}}' +
            '<div class="bg-primary text-dark text-center font-weight-bold p-1 mb-1">' + mpData.translate['topOffers'] + '</div>' +
            '<div class="list-group list-group-flush row no-gutters">' +
            '{{#offers.image_d}}' +
                '<a href="{{URL}}?search={{term}}" data-tracking="headerSearchImage" data-tracking-ident="{{ident}}" class="list-group-item list-group-item-action bg-white border-0 col-6">' +
                    '<div class="mpImg mpHasLabel"><div class="mpImgWrap"><div class="mpImgBg" style="background-image: url({{image}});"></div></div><div class="mpImgLbl">{{title}}</div></div>' +
                '</a>' +
            '{{/offers.image_d}}' +

            // Alternative: untereinander
            /*'<div class="list-group list-group-flush">' +
            '{{#offers.image_d}}' +
                '<a href="{{URL}}?search={{term}}" data-tracking="headerSearchImage" data-tracking-ident="{{ident}}" class="list-group-item list-group-item-action border-0 d-flex">' +
                    '<div class="col-4 col-md-5">' +
                        '<div class="mpImg mpImgContain mpImg4x3"><div class="mpImgWrap"><div class="mpImgBg" style="background-image: url({{image}});"></div></div></div>' +
                    '</div><div class="col-8 col-md-7">' +
                        '<span class="mpEllipsis">{{title}}</span>' +
                    '</div>' +
                '</a>' +
            '{{/offers.image_d}}' +*/
            '</div>' +
        '{{/offers.image_c}}' +
        '{{#offers.c}}' +
            '<div class="bg-primary text-dark text-center font-weight-bold p-1 mb-1">' + mpData.translate['more.offers'] + '</div>' +
            '<div class="list-group list-group-flush">' +
            '{{#offers.d}}' +
                '<a href="{{URL}}?search={{term}}" data-tracking="headerSearch" data-tracking-ident="{{ident}}" class="list-group-item list-group-item-action"><span class="mpEllipsis">{{title}}</span></a>' +
            '{{/offers.d}}' +
            '</div>' +
        '{{/offers.c}}' +
        '{{#offers.any}}' +
            '<div><a href="{{linkSubmitURL}}" class="btn btn-secondary btn-lg w-100 rounded-0" data-tracking="headerSearchLinkSubmit">{{linkSubmitText}}</a></div>' +
        '{{/offers.any}}' +
        '</div>',

    toastBasic: '<div class="toast" role="alert" aria-live="assertive" aria-atomic="true" data-autohide="{{autohide}}" data-delay="{{delay}}">' +
        '<div class="d-flex alert alert-{{alert}} m-0" role="alert" aria-live="assertive" aria-atomic="true"><span class="flex-grow-1">{{message}}</span>' +
            '<button type="button" class="ml-3 close" data-dismiss="toast" aria-label="Close">&times;</button>' +
        '</div>' +
        '</div>',

    letten: 'sepp'
};
